import type { NotifySpoiler } from './../../../../ricos-types';

type Spoiler = {
  notifiers: NotifySpoiler[];
  isActive: boolean;
};

export class SpoilerManager {
  private spoilers: Record<string, Spoiler> = {};

  registerSpoiler = (id: string, notifySpoiler: NotifySpoiler): void => {
    if (!this.spoilers[id]) {
      this.spoilers[id] = { isActive: true, notifiers: [] };
    }
    this.spoilers[id].notifiers.push(notifySpoiler);
  };

  toggleSpoiler = (id: string): void => {
    this.spoilers[id].isActive = !this.spoilers[id].isActive;
    this.spoilers[id].notifiers.forEach(notifySpoiler => notifySpoiler());
  };

  isActive = (id: string): boolean => this.spoilers[id]?.isActive;
}

export default SpoilerManager;
